module.exports = __webpack_public_path__ + "img/diy-eye.2df43756.svg";